import { ActionContext, ActionTree, GetterTree } from "vuex";
import { InspectGensha, InspectDescriptions } from "@/model/InspectGensha";
import { InspectRecommend } from "@/model/InspectRecommend";

export interface InspectState {
  inspect: InspectGensha[]; // md-0004, md-0006
  recommend: InspectRecommend; // md-0008
}

const actions: ActionTree<InspectState, any> = {
  setInspect(
    { commit }: ActionContext<InspectState, any>,
    payload: { data: InspectGensha; index: number }
  ): void {
    commit("setInspect", payload);
  },
  setInspectRecommend(
    { commit }: ActionContext<InspectState, any>,
    payload: InspectRecommend
  ): void {
    commit("setInspectRecommend", payload);
  },
  clearState({ commit }: ActionContext<InspectState, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setInspect(
    state: InspectState,
    payload: { data: InspectGensha; index: number }
  ) {
    state.inspect[payload.index] = { ...payload.data };
  },
  setInspectRecommend(state: InspectState, payload: InspectRecommend) {
    state.recommend = { ...payload };
  },
  clearState(state: InspectState) {
    Object.assign(state, {
      inspect: [{}, {}],
      recommend: {}
    });
  }
};

const getters: GetterTree<InspectState, any> = {
  hasData: (state: InspectState) => (index: number) => {
    return Object.keys(state.inspect[index]).length > 0;
  },
  inspect: (state: InspectState) => (index: number) => {
    return state.inspect[index];
  },
  hasRecommendData(state: InspectState): boolean {
    return Object.keys(state.recommend).length > 0;
  },
  recommend(state: InspectState): InspectRecommend {
    return state.recommend;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: {
    inspect: [{}, {}],
    recommend: {}
  },
  getters,
  actions,
  mutations
};
